import React, { useState } from "react";
import { useGetTiersQuery } from "../../../redux/service/modules/admin";
import PaginatedDataTable from "../../../components/table/PaginatedDataTable";
import Layout from "../../../components/layout/Layout";
import CommonNavigator from "../../../components/common/CommonNavigator";
import { CustomAdminLayout } from "../../../components/layout/CustomAdminLayout";
import TierDialog from "./TierDialog";

const TierDetails = () => {
    const [open, setOpen] = useState(false);
    const [searchText, setSearchtext] = useState("");

    // Debounce function
    const debounce = (func, delay) => {
        let timeoutId;
        return (...args) => {
            if (timeoutId) clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                func(...args);
            }, delay);
        };
    };

    const handleSearch = debounce((value) => {
        setSearchtext(value);
    }, 500);
    return (
        <Layout>
            <div>
                <CustomAdminLayout
                    title={"Tier Details"}
                    createButtonText={"Add New Tier"}
                    createOnClick={() => {
                        setOpen(true);
                    }}
                    showSearchInput
                    showCreateButton={true}
                    onSearch={handleSearch}
                    searchPlaceholder={"Search Tiers"}
                >
                    <PaginatedDataTable
                        queryHook={useGetTiersQuery}
                        title="Tier Management"
                        paginationEnabled={true}
                        showEditColumn={true}
                        showCheckboxColumn={false}
                        appliedFilters={{ search: searchText }}
                        dialogType={"tier"}
                    />
                    <TierDialog
                        open={open}
                        onClose={() => setOpen(false)}
                        isEdit={false}
                        title={"Add New Tier"}
                        ctaText={"ADD TIER"}
                    />
                </CustomAdminLayout>
            </div>
        </Layout>
    );
};

export default TierDetails;
